import { AlertCircleIcon } from "lucide-react"

import { Alert, AlertDescription, AlertTitle, Button } from "@atlant/ui"

export const ErrorFallback = () => (
  <div className="h-screen w-screen">
    <Alert
      variant="destructive"
      className="absolute top-1/2 left-1/2 w-full max-w-md -translate-x-1/2 -translate-y-1/2 transform shadow-lg"
    >
      <AlertCircleIcon className="h-5 w-5" />
      <AlertTitle className="mb-2">Something went wrong</AlertTitle>
      <AlertDescription className="space-y-3">
        <p className="text-sm">We couldn't load this page. Please try refreshing.</p>
        <Button
          variant="outline"
          size="sm"
          onClick={() => window.location.reload()}
          className="w-full"
        >
          Refresh page
        </Button>
        <div className="border-t pt-3">
          <p className="text-muted-foreground mb-2 text-xs font-medium">
            Still having issues?
          </p>
          <ul className="text-muted-foreground space-y-1 text-xs">
            <li className="flex items-start gap-2">
              <span className="mt-0.5">•</span>
              <span>Check your internet connection</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-0.5">•</span>
              <span>Clear your browser cache and try again</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-0.5">•</span>
              <span>Contact support if the problem persists</span>
            </li>
          </ul>
        </div>
      </AlertDescription>
    </Alert>
  </div>
)
